<template>
  <v-card-text :class="type">
    {{ text }}
    <slot />
  </v-card-text>
</template>

<script>
export default {
  name: 'CardText',
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'body-1'
    }
  }
}
</script>
